import React,{useRef,useEffect,useState, useCallback} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import MenuItem from '@mui/material/MenuItem';
import { createTheme, List } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';


import axios from 'axios'



const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const materialTheme = createTheme(({
    component : {

    }
}));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
  productListPaper: {
  
    marginBottom: 50,
  },
  
  paper: {
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
      },
  },
  grow: {
    flexGrow: 1,
  },
}));


const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
  formData.append(key, object[key]);
  
return formData;
}, new FormData());

export default function AutoGenerateInvoiceNumberSettings(props) {

    const [prevSettings, setPrevSettings] = useState(props.autoSalesInvoiceNumberSettings.value)
    const [prevUserTypeSettings, setPrevUserTypeSettings] = useState(props.autoSalesInvoiceNumberSettings.setting)
    const [value, setValue] = React.useState('1');


    const handleSaveAutoGenerateInvoiceNumberSettings = async () => { 

      props.setIsSavingSettings(true)
      const options = {
          method : "POST",
          url : '/TransactiLiteGeneralSettings/saveAutoGenerateInvoiceNumberSettings.json',
          data: objectToFormData({
            value: prevSettings,
            setting: JSON.stringify(prevUserTypeSettings),
          })
      }

      await axios(options)
      .then((res) => {

          props.setIsSavingSettings(false)
          const message = res.data.response.message;
          const is_success = res.data.response.is_success;

          props.setOpenAutoGenInvoiceNumberDialog(false)
          props.setShowMessageDialog(true)
          props.setMessageDialogMessage(message)

          if (is_success) {
            const modifiedSettings = {...props.autoSalesInvoiceNumberSettings, value: prevSettings, setting : prevUserTypeSettings}
            props.setAutoSalesInvoiceNumberSettings(modifiedSettings)
          }
          
      })
      .catch((error) => {

        props.setShowMessageDialog(true)
        props.setMessageDialogMessage(error)
      })
    }
  
    const handleChangeTabs = (event, newValue) => {
      setValue(newValue);
    };

    const handleChangeCheckbox = (event, setting) => { 
      event.stopPropagation()
      
      setPrevUserTypeSettings(prevSettings =>
        prevSettings.map(s =>
          s.user_type_key === setting.user_type_key
            ? { ...s, value: event.target.checked }
            : s
        )
      );
    }
    
    const renderListOfUserTypes = () => { 

      return (
        <List>
          {prevUserTypeSettings.map(setting => (
             <ListItem
              key={setting.user_type_key}
              divider
              style={{ boxShadow: 'none', cursor: 'pointer' }}
            >
              <Checkbox 
                {...label} 
                checked={setting.value} 
                onChange={(e) => handleChangeCheckbox(e, setting)}
                color="success"
              />
              {setting.user_type}
            </ListItem>
          ))}
        </List>
      )
    }

    const renderOptionSettings = () => { 
      return (
        <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={prevSettings}
              label="Age"
              onChange={(evt) => setPrevSettings(evt.target.value)}
            >
            <MenuItem value={1}>ON</MenuItem>
            <MenuItem value={0}>OFF</MenuItem>
            </Select>
        </FormControl>
      )
    }

    return (
        <>
          <div>
            <Dialog 
              fullWidth={true}
              maxWidth={'sm'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              open={props.openAutoGenInvoiceNumberDialog} 
            >
                <DialogTitle> Transacti Lite and Seller Auto-generate Invoice Number Settings</DialogTitle>
                <DialogContent>
                
                  <Grid container spacing={1}style={{ marginBottom: '.5rem' }}>
                      <Grid item xs={12}>
                          <Grid item xs={12}>

                            <Box sx={{ width: '100%', typography: 'body1' }}>
                              <TabContext value={value}>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider'}} >
                                  <TabList 
                                    onChange={handleChangeTabs} 
                                    aria-label="Tabs"  
                                    TabIndicatorProps={{
                                      sx: { backgroundColor: 'rgb(25, 118, 210)' },
                                    }}
                                  >
                                    <Tab 
                                      label="Settings" 
                                      value="1"
                                      sx={{ 
                                        '&.Mui-selected': { color: 'rgb(25, 118, 210)' }, 
                                        '&.Mui-focusVisible': { color: 'rgb(25, 118, 210)' } 
                                      }} 
                                    />

                                    <Tab 
                                      label="Selected User Types" 
                                      value="2" 
                                      sx={{ 
                                        '&.Mui-selected': { color: 'rgb(25, 118, 210)' }, 
                                        '&.Mui-focusVisible': { color: 'rgb(25, 118, 210)' } 
                                      }} 
                                    />
                                  </TabList>
                                </Box>

                                <TabPanel value="1">
                                  {renderOptionSettings()}
                                </TabPanel>

                                <TabPanel value="2">
                                    {renderListOfUserTypes()}
                                </TabPanel>

                              </TabContext>
                            </Box>

                          </Grid>
                      </Grid>
                  </Grid>

                </DialogContent>
                <DialogActions>
                <Button 
                   sx={{ color: 'rgb(25, 118, 210)' }} 
                    onClick={(e) => {
                        e.stopPropagation();
                        props.setOpenAutoGenInvoiceNumberDialog(false)
                    }}
                >
                    Cancel
                </Button>
                
                <Button 
                  sx={{ color: 'rgb(25, 118, 210)' }} 
                  onClick={(e) => {
                      e.stopPropagation();
                      handleSaveAutoGenerateInvoiceNumberSettings()
                  }}
                >
                                Save
                </Button>
                </DialogActions>
            </Dialog>
            </div>
        </>
    )
}